module.exports = __webpack_public_path__ + "static/img/zi7.4c77b81f.png";